export default "__VITE_ASSET__cUb8eOm3__"